import React from "react";
import { Modal, Button } from "react-bootstrap";

function ModalCustom({ show, onHide, title, message, close, isAction = false, onAction = () => {}, textAction = "" }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        {isAction && (
          <Button variant="danger" onClick={onAction}>
            {textAction}
          </Button>
        )}
        <Button variant="secondary" onClick={onHide}>
          {close}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalCustom;


